import { Container, Grid } from '@mui/material'
import React from 'react'
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../Styles/style'

import telegram from "../../../assets/images/telegram.png"
import twitter from "../../../assets/images/twitter.png"
import pulselogo from "../../../assets/images/pulselogo.png"
import styled from '@emotion/styled'

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 } */
`
const FeatureWrapper = styled.div`

height: 327px;
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`
const S7_Roadmap = () => {
    return (
        <div>
            <SectionWrapper p="4rem 0" id="roadmap">
                <Container maxWidth="xl">
                    <SectionHeading p="20px 0" m="0" fs="70px" align="center" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0">
                        Contact
                    </SectionHeading>
                    <JOiningLinks data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0" src={pulselogo} />
                    <GridHEading container spacing={3}>
                        <GridImage item xs={12} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">

                            <P align="center" fs="18px"> Email: contact@pulsepepe.finance</P>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>

                                <a href="https://twitter.com/pulsepepecoin" target="blank" data-aos="zoom-in-up"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="500"
                                    data-aos-duration="500"
                                    data-aos-offset="0">
                                    <JOiningLinks src={twitter} />
                                </a>
                                <a href="https://t.me/pulsepepejoin" target="blank" data-aos="zoom-in-up"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="600"
                                    data-aos-duration="500"
                                    data-aos-offset="0">
                                    <JOiningLinks src={telegram} />
                                </a>
                            </div>
                            <P align="center"
                                p="40px 0"
                                m="0"
                                data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="600"
                                data-aos-duration="600"
                                data-aos-offset="0"
                            >
                                Pulse Pepe on Pulse Chain is a meme-inspired token paying homage to the beloved and recognizable Pepe meme.<br /> With no affiliation to the original creators or their creations, $PEPE has no intrinsic value or financial expectations.
                                <br />
                                <br />
                                It exists solely for entertainment purposes, offering a unique opportunity to invest in the cultural significance and <br />fun-loving spirit of the meme world with no formal team or roadmap.
                               
                            </P>
                            
        </GridImage>

                    </GridHEading>
                </Container>

            </SectionWrapper>
        </div>
    )
}

export default S7_Roadmap